
    <div class="alerts-container">
      <div class="alerts-inner-container">
        <ingo-alert
          [id]="alert.id"
          [type]="alert.type"
          [message]="alert.message"
          *ngFor="let alert of alerts$ | async"
          [@fadeInOut]="">
        </ingo-alert>
      </div>
    </div>